<template>
  <page-template>
    <template
      v-if="!isChild"
      #title
    >
      <div
        class="d-flex align-center justify-start pa-8"
      >
        <page-title
          :title="pageTitle"
          :back-to="navigateBackRoute"
        />
      </div>
    </template>
    <template #content>
      <v-row>
        <v-col cols="12">
          <v-container
            class="py-0"
            fluid
            grid-list-xl
          >
            <v-row>
              <form-group class="ma-0 pa-0 mt-6">
                <slot name="top" />
              </form-group>
            </v-row>
            <v-row>
              <analysis-client-info-display
                ref="info"
              />
            </v-row>
            <v-row>
              <analysis-shortlist-display
                ref="shortlist"
              />
            </v-row>
            <v-row>
              <analysis-photos-info-display
                ref="photos"
                v-model="payload"
              />
            </v-row>
            <v-row>
              <form-group class="ma-0 pa-0">
                <analysis-observation-card
                  :loading="clientInfo.loading"
                />
              </form-group>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from '@/app/arch/template/PageTemplate.vue';
import PageTitle from '@/app/arch/template/PageTitle.vue';
import AnalysisClientInfoDisplay from 'Modules/contacard/analysisTable/components/displays/AnalysisClientInfoDisplay.vue';
import StorageMixin from '@/app/arch/mixins/StorageMixin';
import AnalysisPhotosInfoDisplay from 'Modules/contacard/analysisTable/components/displays/AnalysisPhotosInfoDisplay.vue';
import AnalysisObservationCard from 'Modules/contacard/analysisTable/components/cards/AnalysisObservationCard.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import AnalysisShortlistDisplay from 'Modules/contacard/analysisTable/components/displays/AnalysisShortlistDisplay.vue';

export default {
  name: 'AnalysisTableForm',
  components: {
    PageTemplate,
    PageTitle,
    AnalysisClientInfoDisplay,
    AnalysisPhotosInfoDisplay,
    AnalysisObservationCard,
    FormGroup,
    AnalysisShortlistDisplay,
  },
  mixins: [StorageMixin],
  props: {
    child: {
      type: Boolean,
    },
    value: {
      type: Object,
      default() {
        return {
          id: '',
          cpfCnpj: '',
          idUsuarioAdmin: '',
        };
      },
    },
  },
  data: () => ({
    pageTitle: 'Mesa de análise',
    navigateBackRoute: 'analysisTable.list',
    payload: {},
    client: {
      id: '',
      cpfCnpj: '',
      importadoSgv: '',
    },
    page: {},
    cardFlat: false,
    clientInfo: {
      loading: false,
    },
  }),
  computed: {
    isChild() {
      return this.child;
    },
    getClientStorage() {
      return this.storage.get('@clientTable');
    },
    getClientPayload() {
      return this.isChild
        ? this.value
        : this.getClientStorage;
    },
    getInfoData() {
      const { info } = this.$refs;
      return info ? info.getData : () => {};
    },
    getPhotosData() {
      const { photos } = this.$refs;
      return photos ? photos.getImages : () => {};
    },
    getShortListData() {
      const { shortlist } = this.$refs;
      return shortlist ? shortlist.search : () => {};
    },
    reloadPage() {
      return () => {
        this.getInfoData();
        this.getPhotosData();
        this.getShortListData();
      };
    },
  },
  watch: {
    getClientPayload: {
      immediate: true,
      deep: true,
      handler(client) {
        if (client && typeof client === 'object') {
          if (Number(client.id) >= 1) {
            this.client = client;
          }
        }
      },
    },
    isChild: {
      immediate: true,
      handler(value) {
        if (typeof value === 'boolean') {
          this.cardFlat = value;
        }
      },
    },
    successCallback: {
      immediate: true,
      deep: true,
      handler(cb) {
        if (typeof cb === 'function') {
          this.page.reloadPage = this.reloadPage;
        }
      },
    },
  },
  created() {
    this.$nextTick(
      () => {
        this.page = {
          reloadInfo: this.getInfoData,
          reloadPhotos: this.getPhotosData,
          reloadPage: this.reloadPage,
        };
      },
    );
  },
  methods: {
    setPayload(payload) {
      this.payload = payload;
    },
  },
  reactiveProvide: {
    name: 'analysisTable',
    include: ['payload', 'client', 'page', 'cardFlat', 'clientInfo'],
  },
  provide() {
    return {
      handleAnalysisTablePayload: (payload) => this.setPayload(payload),
      handleClientInfo: (content) => {
        this.clientInfo = content;
      },
      handleClient: (payload) => {
        this.client = payload;
      },
    };
  },
};
</script>
